import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BremaLogo } from "@/components/BremaLogo";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri."); return; }
    if (password !== confirm) { toast.error("Le password non coincidono."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password aggiornata. Ora puoi accedere.");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brema-bg px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-brema-card p-8" data-testid="reset-password-page">
        <div className="mb-6 flex justify-center"><BremaLogo /></div>
        {done ? (
          <div className="text-center" data-testid="reset-success">
            <CheckCircle2 className="mx-auto mb-4 h-9 w-9 text-positive" />
            <p className="text-foreground">Password aggiornata con successo.</p>
            <Link to="/login" className="mt-4 inline-block text-sm font-semibold text-brand hover:underline">Vai al login</Link>
          </div>
        ) : !token ? (
          <div className="text-center">
            <p className="mb-4 text-foreground">Link non valido o mancante.</p>
            <Link to="/login" className="text-sm font-semibold text-brand hover:underline">Vai al login</Link>
          </div>
        ) : (
          <>
            <h1 className="mb-1 text-2xl font-semibold tracking-tight text-foreground">Reimposta la password</h1>
            <p className="mb-6 text-sm text-muted-foreground">Scegli una nuova password per il tuo account.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="np">Nuova password</Label>
                <Input id="np" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password" placeholder="min. 6 caratteri" />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="cp">Conferma password</Label>
                <Input id="cp" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  data-testid="reset-password-confirm" placeholder="ripeti la password" />
              </div>
              <Button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full rounded-full bg-primary font-semibold text-primary-foreground hover:bg-primary/90">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aggiorna password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
